import React from 'react';
import { Link } from "react-router";

const BackToLogin = () =>
    <Link to="/auth/login" className="link block">Back to login</Link>

export default BackToLogin;



// WEBPACK FOOTER //
// ./auth/components/BackToLogin.jsx